import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

import { formatPayment } from './helpers';
import { trackMortgageBannerClick, trackMortgageBannerShow } from './tracking';
import { CianMortgageBanner } from '../../components/CianMortageBanner';
import { getCianMortgageBannerUrl } from '../../utils/config';
import { useApplicationContext } from '../../utils/withApplicationContext';

export interface ICianMortgageBannerContainerProps {
  monthlyPayment: number;
}

export const CianMortgageBannerContainer: React.FC<ICianMortgageBannerContainerProps> = ({ monthlyPayment }) => {
  const { config } = useApplicationContext();
  const bannerUrl = getCianMortgageBannerUrl(config);

  return (
    <ActionAfterViewObserver callback={trackMortgageBannerShow} triggerOnce>
      <CianMortgageBanner
        onClick={trackMortgageBannerClick}
        monthlyPayment={formatPayment(monthlyPayment)}
        url={bannerUrl}
      />
    </ActionAfterViewObserver>
  );
};
